
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Qu’en est-il en Suisse?`}</em></p>
    <p>{`Ce vaccin a été le premier
`}<a parentName="p" {...{
        "href": "https://www.swissmedic.ch/swissmedic/fr/home/news/coronavirus-covid-19/covid-19-impfstoff_erstzulassung.html#116_1608323104130__content_swissmedic_fr_home_news_coronavirus-covid-19_covid-19-impfstoff_erstzulassung_jcr_content_par_columncontrols_items_0_column_tabs"
      }}>{`autorisé par Swissmedic`}</a>{`,
le 19 décembre 2020.`}</p>
    <p>{`Le 4 juin 2021, le même institut a annoncé son
`}<a parentName="p" {...{
        "href": "867048341426"
      }}>{`autorisation chez les adolescents`}</a>{`. L'Office fédéral de la santé
publique (OFSP) a recommandé par la suite la
`}<a parentName="p" {...{
        "href": "316404229400"
      }}>{`vaccination des 12-15 ans`}</a>{`. Et le 26 octobre,
`}<a parentName="p" {...{
        "href": "https://www.swissmedic.ch/swissmedic/fr/home/news/coronavirus-covid-19/genehmigung-booster-impfung.html"
      }}>{`le feu vert a été donné pour l'utilisation d'un booster`}</a>{`
(troisième dose de rappel) pour les personnes vulnérables. Au stade actuel,
`}<a parentName="p" {...{
        "href": "https://www.bag.admin.ch/bag/fr/home/das-bag/aktuell/medienmitteilungen.msg-id-85583.html"
      }}>{`l'OFSP et la Commission fédérale pour les vaccinations recommandent ce rappel aux plus de 65 ans`}</a>{`,
en particulier ceux qui vivent en EMS ou qui ont d'autres maladies graves.`}</p>
    <p>{`La Suisse a d'abord conclu un contrat pour la livraison de 3 millions de doses.
Le 10 mars 2021, on apprenait une commande de 3 millions de doses
supplémentaires.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;